import Seo from "@/components/Seo";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import LeagueStrips from "@/components/LeagueStrips";
import BestSellers from "@/components/BestSellers";
import ShopSection from "@/components/ShopSection";
import BuildYourJersey from "@/components/BuildYourJersey";
import BrandStory from "@/components/BrandStory";
import Newsletter from "@/components/Newsletter";
import ContactSection from "@/components/ContactSection";

const HOME_JSONLD = {
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": "Organization",
      name: "Jersey Blend",
      url: "https://jerseyblend.net",
      logo: "https://jerseyblend.net/og-image.jpg",
    },
    {
      "@type": "WebSite",
      name: "Jersey Blend",
      url: "https://jerseyblend.net",
      potentialAction: {
        "@type": "SearchAction",
        target: "https://jerseyblend.net/?q={search_term_string}#shop",
        "query-input": "required name=search_term_string",
      },
    },
  ],
};

export default function Home() {
  return (
    <div data-testid="home-page">
      <Seo
        title="Custom Soccer, NFL & NBA Fan Jerseys on Hoodies & Tees | Jersey Blend"
        description="Original fan-made soccer (2026 World Cup national teams), NFL & NBA designs printed on premium hoodies and tees. Add your name and number on the back. 7 garment colors, ships in 3–7 days."
        keywords="custom soccer jersey, 2026 World Cup hoodie, custom hoodie with name, personalized jersey with name and number, NFL hoodies, NBA hoodies, custom basketball jersey, football hoodie, national team crest hoodie, personalized sports gift"
        path="/"
        jsonLd={HOME_JSONLD}
      />
      <Hero />
      <Marquee />
      <LeagueStrips />
      <BestSellers />
      <ShopSection />
      <BuildYourJersey />
      <BrandStory />
      <Newsletter />
      <ContactSection />
    </div>
  );
}
